/**
 * Sticky Add to Cart bar
 * - Mobile (<750px): always visible from page load, pinned to viewport bottom.
 * - Desktop (>=750px): hidden until the user scrolls past `.product__outer`
 *   (same -650px boundary used by <sticky-subnav>), then revealed; hides again
 *   when scrolling back up to the hero Add to Bag button.
 *
 * Replaces the previous scroll-listener implementation, which ran
 * getBoundingClientRect() + multiple document.querySelector calls on every
 * scroll frame (forced layout thrashing). IntersectionObserver lets the
 * browser handle this off the main thread instead.
 */
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.handleMediaChange = this.handleMediaChange.bind(this);
    this.observer = null;
  }

  connectedCallback() {
    this.trigger = document.querySelector('.product__outer');
    this.mediaQuery.addEventListener('change', this.handleMediaChange);
    this.updateForViewport();
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    this.disconnectObserver();
  }

  handleMediaChange() {
    this.updateForViewport();
  }

  updateForViewport() {
    this.disconnectObserver();

    if (this.mediaQuery.matches) {
      // Desktop: hidden until the hero Add to Bag button scrolls out of view
      this.classList.add('hidden');
      if (this.trigger) {
        this.observeTrigger();
      }
    } else {
      // Mobile: always visible from page load
      this.classList.remove('hidden');
    }
  }

  observeTrigger() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('hidden', entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '-650px 0px 0px 0px',
      }
    );
    this.observer.observe(this.trigger);
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}